<template>
  <div class="completion-status">
    <el-dialog title="填表完成情况" :visible.sync="dialogTableVisible" :before-close="dialogClose" @open="dialogOpen"
      width="800px">
      <completionStatusTable v-show="mode == 'table' && completionList.length" :total="total" :surveyTableData="surveyTableData" :completionList="completionList"
        @detailClick="detailClick" @currentPageNumChange="currentPageNumChange" @handleSizeChange="handleSizeChange" />
      <studentResponseDetails v-show="mode == 'studentResponseDetails' && studentSurveyResponse" :mode.sync="mode"
        :studentSurveyResponse="studentSurveyResponse" />
    </el-dialog>
  </div>
</template>

<script>
import completionStatusTable from "../completion-status-table/completionStatusTable.vue";
import studentResponseDetails from "../student-response-details/studentResponseDetails.vue";
export default {
  props: ["dialogTableVisible", "completionList", "surveyTableData", "total", "pageSize", "pageNum"],
  components: {
    completionStatusTable,
    studentResponseDetails,
  },
  data() {
    return {
      studentSurveyResponse: null, // 学生回答详情
      mode: "table",
    };
  },
  methods: {
    // 分页组件传递过来的页码修改事件
    currentPageNumChange(pageNum) {
      this.$emit("currentPageNumChange", pageNum);
    },
    handleSizeChange(pageSize) {
      this.$emit("handleSizeChange", pageSize);
    },
    dialogOpen() {
      this.mode = "table";
    },
    // 关闭弹出窗口
    dialogClose() {
      this.$emit("update:dialogTableVisible", false);
    },
    detailClick(row) {
      this.get(
        this.$url.selectStudentSurveyResponse +
        "/" +
        this.surveyTableData.id +
        "/" +
        row.studentId
      ).then((res) => {
        // console.log("获取学生填写详情==：", res);

        if (res.code !== 200) return this.$message.error(res.msg);

        this.studentSurveyResponse = Object.assign({}, row, res.data[0]);

        this.mode = "studentResponseDetails";
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./completionStatusDialog.scss";
</style>